import { any, async, fromJSX, nothing } from "widgets-for-react";
import { features } from "../../../features";
import { hasValue } from "../../../utils/asyncState";
import { scrollToTop } from "../../../utils/browser";
import { nonDefaultSearchParams, parseParamsFromUrl } from "../../../utils/browserQueryParams";
import { emptyJumbo } from "../../Jumbo/Jumbo";
import { EventDetailsLayout } from "./EventDetailsLayout";
import { detailsFilterTemplate, initialDetailFilters } from "./EventFilters/EventFiltersState";
export const EventDetailsWidget = (props)=>{
    const filterSettings = parseParamsFromUrl(initialDetailFilters, detailsFilterTemplate);
    const updateParams = (newSettings)=>{
        const updated = {
            ...filterSettings,
            ...newSettings
        };
        const search = nonDefaultSearchParams(updated, initialDetailFilters);
        props.history.replace(`${window.location.pathname}${search}`);
    };
    const filters = {
        ...filterSettings,
        updateLocation: (location)=>updateParams({
                locations: location ? [
                    location
                ] : []
            }),
        updateRegion: (region)=>updateParams({
                regions: region ? [
                    region
                ] : []
            }),
        updateDateRange: (from, to)=>updateParams({
                from,
                to
            })
    };
    return any({
        key: `ed-${props.eventId}`
    })([
        // Render Layout
        fromJSX(()=>{
            if (props.event.kind == 'failed') return features().error;
            if (!hasValue(props.event)) return props.Jumbo({
                ...emptyJumbo
            });
            return EventDetailsLayout({
                ...props,
                filters,
                event: props.event.value
            });
        }),
        // Manage async state updates
        async(nothing, {
            key: 'eventLoader'
        })(props.event).map((resultUpdater)=>(s0)=>{
                const event = resultUpdater(s0.event);
                if (s0.event.kind != 'loaded' && event.kind == 'loaded') scrollToTop();
                return {
                    ...s0,
                    event
                };
            })
    ]).map((a)=>a(props));
};
